import { cn } from "@/lib/utils";

const initials = (name = "") =>
  name.trim().split(/\s+/).slice(0, 2).map((w) => w[0]?.toUpperCase()).join("") || "?";

export default function AssigneeAvatar({ person, size = "sm", className }) {
  if (!person) return null;
  return (
    <span
      title={person.name}
      data-testid={`assignee-avatar-${person.id}`}
      className={cn(
        "inline-flex items-center justify-center rounded-full bg-[hsl(var(--studio-primary))]/15 text-[hsl(var(--studio-primary))] font-medium shrink-0",
        size === "sm" ? "w-5 h-5 text-[9px]" : "w-7 h-7 text-[11px]",
        className
      )}
    >
      {initials(person.name)}
    </span>
  );
}
